import { AuthContext } from "@src/context/AuthContext";
import React, { useContext } from "react";
import NavbarBg from "@assets/ui-helpers/navbar/navbarbg.png";

const HeaderSkeleton: React.FC = () => {
  const auth = useContext(AuthContext);
  return (
    <div className="relative">
      <header className="max-md:sticky max-md:top-0 max-md:z-[999] bg-blue relative z-[99]">
        <div className="container flex items-center justify-between relative z-[5] py-5 max-lg:p-4">
          <div className="flex items-center gap-3 max-sm:gap-2">
            <div className="w-7 h-7 max-md:w-6 max-md:h-6 bg-gray-300 xl:hidden skeleton rounded"></div>
            <div className="h-[88px] max-md:h-12 w-[176px] max-md:w-24 bg-gray-300 skeleton rounded"></div>
          </div>

          <div
            className="bg-no-repeat bg-100 max-xl:bg-contain bg-center flex items-center justify-center gap-8 max-2xl:gap-7 max-xl:hidden py-8 px-10"
            style={{ backgroundImage: `url(${NavbarBg})` }}
          >
            <div className="h-6 w-32 max-2xl:w-28 bg-gray-300 skeleton rounded"></div>
            <div className="h-6 w-32 max-2xl:w-28 bg-gray-300 skeleton rounded"></div>
            <div className="h-6 w-32 max-2xl:w-28 bg-gray-300 skeleton rounded"></div>
            <div className="h-6 w-28 bg-gray-300 skeleton rounded"></div>
            <div className="h-6 w-36 max-2xl:w-32 bg-gray-300 skeleton rounded"></div>
            <div className="h-6 w-32 max-2xl:w-28 bg-gray-300 skeleton rounded max-2xl:hidden"></div>
          </div>

          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2 max-[350px]:gap-1 relative">
              {!auth && (
                <h3 className="text-white text-xl truncate max-w-[90px] max-xl:hidden">
                  <div className="h-4 w-16 bg-gray-300 skeleton rounded"></div>
                </h3>
              )}
              <h3 className="text-white text-xl truncate max-w-[90px] max-xl:hidden">
                <div className="h-4 w-16 bg-gray-300 skeleton rounded"></div>
              </h3>
              <button className="rounded-full w-[56px] h-[56px] max-xl:w-12 max-xl:h-12 duration-150 hover:scale-95 overflow-hidden">
                <div className="size-full bg-gray-300 skeleton rounded"></div>
              </button>
              {
                <button className="rounded-full w-[56px] h-[56px] max-xl:w-12 max-xl:h-12 duration-150 hover:scale-95 overflow-hidden">
                  <div className="size-full bg-gray-300 skeleton rounded"></div>
                </button>
              }
              {auth && (
                <button className="rounded-full w-[56px] h-[56px] max-xl:w-12 max-xl:h-12 duration-150 hover:scale-95 overflow-hidden">
                  <div className="size-full bg-gray-300 skeleton rounded"></div>
                </button>
              )}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default HeaderSkeleton;
